import { render, staticRenderFns } from "./_Option.vue?vue&type=template&id=5f9dc6f5&scoped=true"
import script from "./_Option.vue?vue&type=script&lang=js"
export * from "./_Option.vue?vue&type=script&lang=js"
import style0 from "./_Option.vue?vue&type=style&index=0&id=5f9dc6f5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9dc6f5",
  null
  
)

export default component.exports